import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { compose } from 'ramda';

import { Image } from './imageSlide.styles';
import { EntityRefData } from '../../../../shared/components/entityRefData';

const IMAGE_SIZES = [160, 384, 640, 960];

export class ImageSlideComponent extends PureComponent {
  static propTypes = {
    image: PropTypes.string,
  };

  render() {
    return (
      <EntityRefData id={this.props.image}>
        {({ file }) => <Image imgProps={{ sizes: '50vw' }} file={file} sizes={IMAGE_SIZES} />}
      </EntityRefData>
    );
  }
}

export const ImageSlide = compose(injectIntl)(ImageSlideComponent);
